<div class="container live-single-eventlist">
  <div class="header">
    <div class="header-text">{{ 'Football' | t }}</div>
  </div>
  <div class="content">
    <div class="sports-container live-single">
      <div class="odd-header">
        <div class="odd-combo-row-full">
          <div class="combo-box-full">
            <select [(ngModel)]="combo1SelectedOdd" (change)="oddComboChange(combo1SelectedOdd, 0)">
              <option *ngFor="let odd of oddComboList" [ngValue]="odd">
                {{ odd.OddName | t }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <ng-container *ngFor="let _d of __ResultLiveData; index as i; last as lastItem">
        <div *ngIf="_d.type === 'TournamentName'" class="live-single-tournament">{{ _d.SportName }} > {{ _d.TournamentName }}</div>

        <div class="live-single-match" *ngIf="_d.type === 'Match'">
          <div class="match-info-teams" (click)="goEventDetail2(_d.MatchId, _d.EventId, _d)">
            <div class="team">{{ _d.HomeTeam }}</div>
            <div class="team">{{ _d.AwayTeam }}</div>
          </div>
          <div></div>
          <div class="match-row-score-board" *ngIf="_d.Score?.split(':')[0] !== '-' && _d.Score?.split(':')[1] !== '-'">
            <ng-container *ngIf="_d.SportNameOriginal === 'Soccer'">
              <div class="score-board-box now">
                <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">{{ _d.Score?.split(':')[0] }}</span>
                <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">{{ _d.Score?.split(':')[1] }}</span>
              </div>
              <div class="score-board-box">
                <span *ngIf="_d.GameScore?.split(':')[0] !== '-'">({{ _d.GameScore?.split(':')[0] }})</span>
                <span *ngIf="_d.GameScore?.split(':')[1] !== '-'">({{ _d.GameScore?.split(':')[1] }})</span>
              </div>
            </ng-container>

            <ng-container *ngIf="_d.SportNameOriginal === 'Basketball' || _d.SportNameOriginal === 'Ice Hockey' || _d.SportNameOriginal === 'Field Hockey'">
              <div class="score-board-box now">
                <span class="{{ _d.homegoalcss }}" *ngIf="_d.Score?.split(':')[0] !== '-'">
                  {{ _d.Score?.split(':')[0] }}
                </span>
                <span class="{{ _d.awaygoalcss }}" *ngIf="_d.Score?.split(':')[1] !== '-'">
                  {{ _d.Score?.split(':')[1] }}
                </span>
              </div>
            </ng-container>

            <ng-container *ngIf="_d.SportNameOriginal === 'Tennis' || _d.SportNameOriginal === 'Volleyball'">
              <div class="score-board-box now">
                <span>{{ _d.Score?.split(':')[0] }}</span>
                <span>{{ _d.Score?.split(':')[1] }}</span>
              </div>
              <div class="score-board-box">
                <span>{{ _d.GameScore?.split(':')[0] }}</span>
                <span>{{ _d.GameScore?.split(':')[1] }}</span>
              </div>
              <div class="score-board-box">
                <span>{{ _d.GameScore2?.split(':')[0] }}</span>
                <span>{{ _d.GameScore2?.split(':')[1] }}</span>
              </div>
              <div class="score-board-box">
                <span>{{ _d.GameScore3?.split(':')[0] }}</span>
                <span>{{ _d.GameScore3?.split(':')[1] }}</span>
              </div>
              <div class="score-board-box">
                <span>{{ _d.LegScoreHome }}</span>
                <span>{{ _d.LegScoreAway }}</span>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="live-single-score" *ngIf="_d.type === 'Match'">
          <ng-container
            *ngIf="_d.SportNameOriginal === 'Soccer' || _d.SportNameOriginal === 'Basketball' || _d.SportNameOriginal === 'Ice Hockey' || _d.SportNameOriginal === 'Field Hockey'">
            {{ _d.MatchTimeExtended == null ? (_d.EventDate && _d.EventDate != NaN ? (_d.EventDate | dateFormat : 'h:mm a') : _d.MatchTimeExtended) : _d.MatchTimeExtended + "'" }}
          </ng-container>

          <ng-container *ngIf="_d.SportNameOriginal === 'Tennis' || _d.SportNameOriginal === 'Volleyball'">
            {{ _d.TimeStatuColor }}
          </ng-container>
        </div>
        <div class="match-row-container live-single-row" *ngIf="_d.type === 'Match'">
          <div class="match-row-odds">
            <ng-container *ngFor="let _y of oddTypeArray; let indexItem = index">
              <ng-container *ngIf="!mLine[_y]">
                <div class="odds-box live-single-odds">
                  <ng-container *ngFor="let a of oddDatas[_y]">
                    <div
                      *ngIf="_d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden' && _d['OddValue' + a.type] !== ''"
                      class="odd {{ checkOddId(_d['OddId' + a.type]) }}"
                      (click)="clickOddUP(_d['OddId' + a.type], _d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden')">
                      <span class="odd-text" *ngIf="!a.preTextT">{{ a.preText }}</span>
                      <span class="odd-text" *ngIf="a.preTextT">{{ a.preTextT | t }}</span>
                      <span class="odd-value">{{ _d['OddValue' + a.type] | number : '1.2-2' }}</span>
                      <!-- downarrow - uparrow animation -->
                      <div class="{{ _d['OddValue' + a.type + 'css'] }}"></div>
                      <!-- downarrow - uparrow animation -->
                    </div>
                    <div class="odd" *ngIf="_d['OddValue' + a.type] == null || _d['OddValue' + a.type + 'Visibility'] === 'hidden' || _d['OddValue' + a.type] === ''">
                      <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="mLine[_y]">
                <div class="odds-box live-single-odds">
                  <ng-container *ngFor="let a of oddDatas[_y][0] | slice : 0 : 3; let indexItem = index">
                    <div
                      class="odd special"
                      *ngIf="(_y == 1 || _y == 2 || _y == 7 || _y == 10 || _y == 14 || _y == 16 || _y == 17 || _y == 18 || _y == 20 || _y == 22) && indexItem == 0">
                      <span class="odd-text">
                        <ng-container *ngIf="_y == 1 || _y == 22">
                          {{ 'hc' | t }}
                        </ng-container>
                        <ng-container *ngIf="_y == 2 || _y == 7 || _y == 14">
                          {{ 'bet3000_Goals' | t }}
                        </ng-container>
                        <ng-container *ngIf="_y == 18 || _y == 20">
                          {{ 'TennisSet_Long' | t }}
                        </ng-container>
                        <ng-container *ngIf="_y == 10 && _sportName !== 'Tennis' && _sportName !== 'Volleyball' && _sportName !== 'Basketball' && _sportName !== 'Table tennis'">
                          {{ 'bet3000_Goals' | t }}
                        </ng-container>
                        <ng-container
                          *ngIf="
                            (_y == 10 || _y == 16 || _y == 17) &&
                            (_sportName === 'Tennis' || _sportName === 'Volleyball' || _sportName === 'Basketball' || _sportName === 'Table tennis')
                          ">
                          {{ 'Point_Long' | t }}
                        </ng-container>
                      </span>
                      <span class="odd-value">{{ _d['OddSpecialBetValue' + a.lineText] }}</span>
                      <div></div>
                    </div>

                    <div
                      *ngIf="_d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden' && _d['OddValue' + a.type] !== ''"
                      class="odd {{ checkOddId(_d['OddId' + a.type]) }} "
                      (click)="clickOddUP(_d['OddId' + a.type], _d['OddValue' + a.type] != null && _d['OddValue' + a.type + 'Visibility'] !== 'hidden')">
                      <span class="odd-text" *ngIf="!a.preTextT">{{ a.preText }}</span>
                      <span class="odd-text" *ngIf="a.preTextT">{{ a.preTextT | t }}</span>
                      <span class="odd-value">{{ _d['OddValue' + a.type] | number : '1.2-2' }}</span>
                      <!-- downarrow - uparrow animation -->
                      <div class="{{ _d['OddValue' + a.type + 'css'] }}"></div>
                      <!-- downarrow - uparrow animation -->
                    </div>

                    <div class="odd lock" *ngIf="_d['OddValue' + a.type] == null || _d['OddValue' + a.type + 'Visibility'] === 'hidden' || _d['OddValue' + a.type] === ''">
                      <image-loader-utils url="fa-lock" extraClasses="lock-icon"></image-loader-utils>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
